// extracted by mini-css-extract-plugin
export default {"innerWrapper":"pv-z","tooltipWrapper":"qv-z","icon":"rv-z","tooltip":"sv-z","content":"tv-z"};